import { useMemo } from 'react';
import {
  Box,
  Container,
  Grid,
  Link as MaterialLink,
  Typography,
} from '@mui/material';
import { useUsuario } from '../../../../providers/usuarioProvider';
import RenderAnimation from '../../../util/ui/renderAnimation';
import CardPatrimonio from '../../analises/patrimonio';
import CardProdutos from '../../analises/produtos';
import Conectar from '../cards/conectar';
import Calculos from '../cards/calculos';
import PermissaoDisplay from '../../../util/permissaoDisplay';
import ProximosProventos from './cards/proximosProventos';
import FelixTour from '../../../util/felixTour';
import { Link } from 'react-router-dom';

export default function PainelInvestidor() {
  const { usuario } = useUsuario();
  if (!!!usuario) return <></>;

  const cardConectar = useMemo(() => <Conectar />, []);
  const cardCalculos = useMemo(() => <Calculos />, []);
  const cardPatrimonio = useMemo(() => <CardPatrimonio />, []);
  const cardProdutos = useMemo(() => <CardProdutos />, []);
  const cardProximosProventos = useMemo(() => <ProximosProventos />, []);

  const gridItems = [
    {
      key: 'header',
      xs: 12,
      render: () => (
        <Box className="boas-vindas">
          <Typography variant="eyebrow" color="text.secondary">
            Painel
          </Typography>
          <Typography variant="h1" color="text.primary" mt={0.5}>
            {`Olá, `}
            <MaterialLink
              component={Link}
              color="inherit"
              to="/conta"
              underline="hover"
              sx={{ fontStyle: 'italic', color: 'accentInk' }}
            >
              {usuario?.nome || 'Investidor'}
            </MaterialLink>
            {` 👋`}
          </Typography>
        </Box>
      ),
    },
    {
      key: 'conectar',
      xs: 12,
      md: 6,
      render: () => cardConectar,
    },
    {
      key: 'atualizar',
      xs: 12,
      md: 6,
      render: () => cardCalculos,
    },
    {
      key: 'patrimonio',
      xs: 12,
      md: 12,
      render: () => (
        <PermissaoDisplay
          match={(claims) => !!claims?.permissoes?.ver_analises}
        >
          {cardPatrimonio}
        </PermissaoDisplay>
      ),
    },
    {
      key: 'produtos',
      xs: 12,
      md: 8,
      render: () => (
        <PermissaoDisplay
          match={(claims) => !!claims?.permissoes?.ver_analises}
        >
          {cardProdutos}
        </PermissaoDisplay>
      ),
    },
    {
      key: 'destaque-blog',
      xs: 12,
      md: 4,
      render: () => cardProximosProventos,
    },
  ];

  return (
    <Container
      maxWidth="lg"
      sx={{
        p: (theme) => ({
          md: theme.spacing(4, 8),
          xs: theme.spacing(2),
        }),
      }}
    >
      <Grid container alignItems="stretch" alignContent="stretch">
        {gridItems.map((item, index) => (
          <Grid key={item.key} item xs={item.xs} md={item.md} p={1}>
            <RenderAnimation
              key={item.key}
              delay={index * 300}
              render={item.render}
            />
          </Grid>
        ))}
      </Grid>
      <FelixTour />
    </Container>
  );
}
